/**
 * Approximate geographic centers [lng, lat] for USA map features (`properties.name`)
 * aligned with USPS_TO_USA_FEATURE_NAME / choroplethRegionFeatureName output.
 */

export const USA_FEATURE_NAME_TO_CENTER_LNG_LAT = {
    Alabama: [-86.79, 32.81],
    Alaska: [-152.404, 65.37],
    Arizona: [-111.431, 33.7298],
    Arkansas: [-92.4426, 35.2033],
    California: [-119.746, 36.7796],
    Colorado: [-105.783, 39.0654],
    Connecticut: [-72.7594, 41.7467],
    Delaware: [-75.4154, 38.9577],
    'District of Columbia': [-77.0268, 38.9173],
    Florida: [-82.4784, 28.5964],
    Georgia: [-83.4078, 32.9866],
    Hawaii: [-157.854, 20.7947],
    Idaho: [-115.089, 44.4785],
    Illinois: [-88.9868, 40.0796],
    Indiana: [-86.1395, 40.0691],
    Iowa: [-93.5265, 42.0696],
    Kansas: [-98.3804, 38.5276],
    Kentucky: [-85.9289, 37.8393],
    Louisiana: [-91.9623, 30.9745],
    Maine: [-69.0651, 45.6932],
    Maryland: [-76.9716, 39.0653],
    Massachusetts: [-71.6301, 42.3795],
    Michigan: [-85.6137, 44.9868],
    Minnesota: [-94.3053, 46.6892],
    Mississippi: [-89.6678, 32.5851],
    Missouri: [-92.7664, 38.627],
    Montana: [-110.454, 47.0527],
    Nebraska: [-99.6947, 41.4919],
    Nevada: [-116.894, 40.0976],
    'New Hampshire': [-71.5653, 43.9838],
    'New Jersey': [-74.521, 40.0583],
    'New Mexico': [-106.248, 34.5794],
    'New York': [-75.2272, 42.9869],
    'North Carolina': [-79.8877, 35.7596],
    'North Dakota': [-100.466, 47.9671],
    Ohio: [-82.7649, 40.5592],
    Oklahoma: [-97.5089, 35.7432],
    Oregon: [-120.558, 44.0639],
    Pennsylvania: [-77.7498, 40.9835],
    'Puerto Rico': [-66.59, 18.221],
    'Rhode Island': [-71.5562, 41.7492],
    'South Carolina': [-81.0748, 33.7347],
    'South Dakota': [-100.348, 44.4914],
    Tennessee: [-86.8373, 35.9568],
    Texas: [-99.3312, 31.0545],
    Utah: [-111.892, 40.0965],
    Vermont: [-72.7317, 44.0689],
    Virginia: [-78.8537, 37.9243],
    Washington: [-121.082, 47.5265],
    'West Virginia': [-80.8882, 38.9327],
    Wisconsin: [-89.8065, 44.7931],
    Wyoming: [-108.742, 42.9745],
};

/**
 * @param {string} featureName from choroplethRegionFeatureName(...)
 * @returns {[number, number] | null}
 */
export function usaFeatureCenterLngLat(featureName) {
    if (!featureName || typeof featureName !== 'string') return null;
    const center = USA_FEATURE_NAME_TO_CENTER_LNG_LAT[featureName.trim()];
    if (!center || center.length < 2) return null;
    const [lng, lat] = center;
    return Number.isFinite(lng) && Number.isFinite(lat) ? center : null;
}
